import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle } from '../../ui/alert';
import { Button } from '../../ui/button';
import IconWrapper from '../../IconWrapper';
import { FiX, FiRefreshCw } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

interface SimulationPromptBannerProps {
  onRunSimulation: () => void;
  onDismiss: () => void;
  evidenceCount?: number;
  autoDismissMs?: number;
}

const SimulationPromptBanner: React.FC<SimulationPromptBannerProps> = ({
  onRunSimulation,
  onDismiss,
  evidenceCount = 1,
  autoDismissMs = 30000 // 30 seconds
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (autoDismissMs > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onDismiss();
      }, autoDismissMs);

      return () => clearTimeout(timer);
    }
  }, [autoDismissMs, onDismiss]);

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.2 }}
      >
        <Alert className="border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-900 dark:bg-blue-900/20 dark:text-blue-200 mb-4">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2">
              <IconWrapper icon={FiRefreshCw} className="h-4 w-4" />
              <AlertTitle className="mb-0">New evidence uploaded</AlertTitle>
            </div>
            <div className="flex items-center gap-2">
              <Button
                size="sm"
                onClick={() => {
                  setIsVisible(false);
                  onRunSimulation();
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                Run Simulation
              </Button>
              <button
                onClick={() => {
                  setIsVisible(false);
                  onDismiss();
                }}
                className="p-1 rounded hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors"
                aria-label="Dismiss"
              >
                <IconWrapper icon={FiX} className="w-4 h-4" />
              </button>
            </div>
          </div>
        </Alert>
      </motion.div>
    </AnimatePresence>
  );
};

export default SimulationPromptBanner;

